import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { InMemoryCache } from 'apollo-cache-inmemory'
import vuetifyToast from 'vuetify-toast'

const isElectron = window && window.process && window.process.versions['electron']
const backendUri = (isElectron || !location || location.hostname == 'localhost') ? 'http://localhost:5001/graphql' : location.origin + '/graphql';
console.log(`backend at ${backendUri}`);

const httpLink = new HttpLink({
  uri: backendUri,
})
  
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: 
      token ?
        {
          ...headers,
          authorization: `Bearer ${token}`
        }
      : headers
  }
})

const errorLink = onError(({operation, response, graphQLErrors, networkError}) => {
  console.log('[ERR] operation', operation)
  console.log('[ERR] response', response)
  const messages = []
  if (graphQLErrors) {
    for (const error of graphQLErrors) {
      messages.push(error.message)
    }
  }
  if (networkError) {
    switch (networkError.statusCode) {
      case 401:
      case 403:
        if (messages.includes("jwt malformed") || messages.includes("jwt expired")) {
          delete localStorage.token
          setTimeout(() => { 
            if (isElectron) {
              window.vm.$router.push({ name: "userSelect" });
            } else {
              location.pathname = '' 
            }
          }, 3000)
        }
        break;
    }
  }
  vuetifyToast.error(messages.join(', '))
})

const apolloClient = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
  connectToDevTools: true,
})
  
export default apolloClient;
